<template>
  <nav class="form-input-set">
    <template v-if="!isHeaderHidden">
      <label v-if="hasSlotLabel" :id="id">
        <span><slot name="label"></slot></span>
      </label>

      <div class="btn-sectioned offset-bottom-1" role="tablist" :aria-labelledby="id">
        <VButton
          v-for="t in headers"
          :key="t.name"
          :label="t.label"
          :title="t.title ? $to(t.title) : $tt(t.label)"
          class="btn-default"
          role="tab"
          :active="t.isActive"
          :selected="t.isActive"
          :aria-controls="'tab-' + t.name"
          @click="$emit('select', t)"
        />
      </div>
    </template>

    <slot />
  </nav>
</template>

<script>
import VButton from '@/components/Button';

export default {
  name: 'TabsetLayoutButton',

  components: {
    VButton,
  },

  props: {
    headers: {
      type: Array,
      required: true,
    },

    selected: {
      type: Object,
      required: false,
      default: null,
    },

    noSingleHeader: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      id: Math.random()
        .toString(36)
        .substring(2),
    };
  },

  computed: {
    hasSlotLabel() {
      return this.$scopedSlots.label;
    },

    isHeaderHidden() {
      return this.noSingleHeader && this.headers.length === 1;
    },
  },
};
</script>
